import { currencyFormatter } from '@dnhb/formatters';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'shared/hooks';
import {useLocation} from 'react-router-dom';
import analytics from 'shared/utility/analytics';
import { Collapsable, DisplayLink, Display, Heading, LabelText } from 'shared/components';
import { NAVIGATE, SYNC } from 'shared/wizard/actions';

const WizardResults = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const {
    pages,
    settings: { mortgage_providers },
    input: {
      mortgage_provider_id,
      mortgage_provider_label,
      has_nhg,
      original_mortgage_amount,
      original_house_value,
      current_mortgage_amount,
      current_house_value,
    },
  } = useSelector(state => state);

  useEffect(() => {
    dispatch({ type: SYNC, syncing: false });
    analytics.send('Bereken', 'Resultaten');
  }, []);

  const currentPage = location.state?.page;
  const currentPageIndex = pages.indexOf(currentPage);
  const chosenProvider = mortgage_providers.find(provider => provider.value === mortgage_provider_id);
  const chosenProviderLabels = chosenProvider?.labels || [];
  const chosenReadableLabel = chosenProviderLabels.find(label => label.value === mortgage_provider_label)?.label;

  return (
    <>
      <Heading>Uitgangspunten</Heading>
      <LabelText css={{ marginBottom: '24px' }}>
        Controleer of je gegevens juist zijn; pas deze zo nodig aan voor de juiste berekening.
      </LabelText>
      <Collapsable title="Je hypotheek" openByDefault>
        <Display label="Huidige verstrekker" value={chosenProvider?.label} />
        {chosenProviderLabels.length > 2 && (
          <Display label="Huidige label" value={chosenReadableLabel} />
        )}
        <Display label="NHG" value={has_nhg} />
        <DisplayLink
          onClick={() => {
            dispatch({ type: NAVIGATE, recalculate: currentPageIndex, index: 0 });
          }}
        >
          Gegevens aanpassen
        </DisplayLink>
      </Collapsable>
      <Collapsable title="Situatie bij de start">
        <Display label="Hoogte van je hypotheek" value={currencyFormatter(original_mortgage_amount, 0)} />
        <Display label="Waarde van de woning" value={currencyFormatter(original_house_value, 0)} />
        <DisplayLink
          onClick={() => {
            dispatch({ type: NAVIGATE, recalculate: currentPageIndex, index: 1 });
          }}
        >
          Gegevens aanpassen
        </DisplayLink>
      </Collapsable>
      <Collapsable title="Huidige situatie">
        <Display label="Hoogte van je hypotheek" value={currencyFormatter(current_mortgage_amount, 0)} />
        <Display label="Waarde van de woning" value={currencyFormatter(current_house_value, 0)} />
        <DisplayLink
          onClick={() => {
            dispatch({ type: NAVIGATE, recalculate: currentPageIndex, index: 2 });
          }}
        >
          Gegevens aanpassen
        </DisplayLink>
      </Collapsable>
    </>
  );
};

export default WizardResults;
